export default __webpack_public_path__ + "static/media/down-arrow.7ed97420.svg";